// Master JS for Sign In page

import { WireupHandlers, SetLoadingState } from "./lib/data-wireup.js";
import { PostJSON } from "./lib/fetchers.js";
import { FormToObject, WireupPasswordReveal } from "./lib/form-utilities.js";
import { LoadFacebookSdk, WireupFacebookSignIn } from "./lib/facebook.js";
import { WireupRecaptcha, ExecuteRecaptcha } from "./lib/recaptcha.js";

import { SubmitStatus } from "./webcomponents/submit-status.js";

// Register required webcomponents
SubmitStatus.Register();

LoadFacebookSdk();
WireupFacebookSignIn("signin-status");
WireupPasswordReveal();
WireupRecaptcha("recaptcha-container", onReCaptchaSubmit, "signin-status");

// Note: we don't set the button loading state here because we have to wait until after recaptcha processes, in case they click out
WireupHandlers("signin", "submit", async () => {
    SubmitStatus.Hide("signin-status");
    ExecuteRecaptcha();
});

/** On recaptcha success, sign in */
async function onReCaptchaSubmit(token) {
    SetLoadingState("signinsubmit", true);
    try {
        const data = FormToObject(document.querySelector("[data-wireup-signin]"));
        data.token = token;
        const result = await PostJSON("/users/sign_in", data);
        // Leave the button loading while the redirect happens
        window.location = result.returnUrl;
    } catch (err) {
        SubmitStatus.Set("signin-status", err.serverMessage || "The action did not complete. Please try again.", true);
        SetLoadingState("signinsubmit", false);
    }
}
